var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99961 14.5C9.98389 14.5 8.40752 14.4993 6.67769 14.448C3.77275 14.3616 2.63218 14.2013 2.18682 14.082C1.32549 13.852 0.648047 13.1742 0.418359 12.3132C0.00478516 10.772 0 7.53179 0 7.49932C0 7.46685 0.00478516 4.22798 0.418359 2.68579C0.648389 1.82549 1.32583 1.14805 2.18682 0.918018C2.63218 0.79873 3.77275 0.638428 6.67769 0.551953C8.40752 0.500684 9.98389 0.5 9.99961 0.5C10.0153 0.5 11.592 0.500684 13.3219 0.551953C16.2271 0.638428 17.3681 0.79873 17.8134 0.918018C18.6741 1.14771 19.3519 1.82515 19.5826 2.68579C19.9955 4.22661 20.0002 7.46685 20.0002 7.49932C20.0002 7.53179 19.9955 10.7734 19.5826 12.3132C19.3519 13.1742 18.6741 13.8523 17.8134 14.082C17.3681 14.2013 16.2271 14.3616 13.3219 14.448C11.592 14.4993 10.0153 14.5 9.99961 14.5ZM7.82339 2.56069V12.4383L13.3465 7.49932L7.82339 2.56069Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeVideoIcon);
export default __webpack_public_path__ + "static/media/youtubeVideoIcon.4f86fd3d5b9da48b42432954aa834b48.svg";
export { ForwardRef as ReactComponent };